import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import modules from './modules'
import state from './state'
// import createLogger from 'vuex/dist/logger'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production' && !process.env.ONLINE

const vuexLocal = new VuexPersistence({
  key: 'cityAreaLocal',
  storage: window.localStorage,
  reducer: state => {
    return {
      commonAreaChecked: state.bizoppV2.commonAreaChecked,
      cityID: state.bizoppV2.cityIdsWithAuth,
      store: {
        filterOptions: {
          potential: state.store.filterOptions.potential,
          rPerformance: state.store.filterOptions.rPerformance,
          cityIds: state.store.filterOptions.cityIds,
          areaCityIds: state.store.filterOptions.areaCityIds,
          arrTag: state.store.filterOptions.arrTag,
          bdUserName: state.store.filterOptions.bdUserName
        },
        filterValue: {
          cityId: state.store.filterValue.cityId,
          bdAreaIds: state.store.filterValue.bdAreaIds,
          AreaCityId: state.store.filterValue.AreaCityId,
          AreaAreaIds: state.store.filterValue.AreaAreaIds
        }
      }
    }
  }
})

const vuexLocalGas = new VuexPersistence({
  key: 'cityAreaLocalGas',
  storage: window.localStorage,
  reducer: state => {
    const {
      status = [],
      type = [],
      erpStatus = [],
      bizStatus = [],
      group = [],
      brand = [],
      cityTree
    } = state.gasStore.filterOptions
    const {
      cityId,
      bdAreaIds
    } = state.gasStore.filterValue
    return {
      gasStore: {
        filterOptions: {
          status,
          type,
          erpStatus,
          bizStatus,
          group,
          brand,
          cityTree
        },
        filterValue: {
          cityId,
          bdAreaIds
        }
      }
    }
  }
})

export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  modules,
  strict: debug,
  plugins: debug ? [vuexLocal.plugin, vuexLocalGas.plugin] : [vuexLocal.plugin, vuexLocalGas.plugin]
})
